import Client from "../client";
import VendorStaffGateway from "@/usecases/gateways/vendor-staff-gateway";
import VendorStaff from "@/models/vendor-staff";
import { client } from "../request";

export default class VendorStaffApi implements VendorStaffGateway {
  public constructor(private client: Client) {}

  /**
   * 作業者の一覧を得る
   */
  public async findByProjectId(projectId: number): Promise<VendorStaff[]> {
    const res = await this.client.get("get_all_vendor_private_staffs.php", {
      projectId
    });
    return res.staffList.map(toVendorStaff);
  }
}

function toVendorStaff(data: any): VendorStaff {
  return {
    id: data.staffId,
    name: data.name,
    vendorId: data.officeId,
    workTypeIds: data.workTypeIds,
    serviceTaskTypeId: data.serviceTaskTypeId
  };
}

interface GetOperatorsQuery {
  projectId: number;
}

/**
 * 現場の作業者の候補を得る
 */
export async function getProjectOperators({
  projectId
}: GetOperatorsQuery): Promise<VendorStaff[]> {
  return await new VendorStaffApi(client).findByProjectId(projectId);
}
